/**
 * Created by rhinov15 on 23/01/2017.
 */

import { DimensionNode } from "./DimensionNode";
import { CocosConstants } from "../../../../constants";
import { PlanManager } from "../../../../cocosPlan";
import { ComponentConstants, Entity, eventsManager, KitchenTool, math, SavaneMath, SceneConstants, Segment } from "@rhinov/savane-js";

declare var cc: any;


export class SketchBlockNode extends cc.DrawNode {
    constructor(entity: Entity) {
        super();
        //
        this.sketchBlock = entity;
        //Add dimension
        if (this.sketchBlock.objectType === SceneConstants.ArrangementType.kitchenFurnitureBottom ||
            this.sketchBlock.objectType === SceneConstants.ArrangementType.kitchenFurnitureColumn) {
            this.dimLine = 1;
            this.dimColor = new cc.Color(200, 85, 100);
            this.dimensionNode = new DimensionNode(this.dimColor);
        } else if (this.sketchBlock.objectType === SceneConstants.ArrangementType.kitchenFurnitureTop) {
            this.dimLine = 2;
            this.dimColor = new cc.Color(70, 85, 200);
            this.dimensionNode = new DimensionNode(this.dimColor);
        } else {
            this.dimensionNode = null;
        }
        this.angleDimensionNode = null;
        this.rightFillerDimensions = null;
        this.leftFillerDimensions = null;
        if (this.dimensionNode !== null) {
            if (this.sketchBlock.objectTypeConfig !== undefined && this.sketchBlock.objectTypeConfig !== null &&
                this.sketchBlock.objectTypeConfig.angleDirection !== undefined && this.sketchBlock.objectTypeConfig.angleDirection !== 'none') {
                this.angleDimensionNode = new DimensionNode(this.dimColor);
                this.angleDimensionNode.setDimensionValue(this.sketchBlock.width / 10, PlanManager.getInstance().getZoomScale());
                this.angleDimensionNode.setRotation(90);
                this.addChild(this.angleDimensionNode, 7);
            }
            this.dimensionNode.setName('Dim box');
            this.calculateDimensionsNodes();
            this.dimensionNode.setDimensionValue(this.sketchBlock.length / 10, PlanManager.getInstance().getZoomScale());
            //this.dimensionNode.setLocalScale(this.sketchBlock.length);
            this.addChild(this.dimensionNode, 7);
        }
        this.resetColor();
        this.redraw();
        this.symbol = null;
    }

    calculateDimensionsNodes () {
        if (this.dimensionNode === null) {
            return; // No dimension node for that sketchblock
        }
        var i, j; //iterator
        var wall_bbox, wall_seg, c_point; //walls values
        var touch_wall_back = false;
        var touch_wall_angle = false;
        var wall_thick = 0; // Thickness of wall to decal dimensions from proper amount
        var wall_thick_angle = 0;
        //Extract bbox of arrangement
        var arr_bbox = this.sketchBlock.boundingBox;
        //Create segement from front of arrangement to rear side
        var front_to_back_seg = new Segment(SavaneMath.getMiddle(arr_bbox[0], arr_bbox[3]), SavaneMath.getMiddle(arr_bbox[2], arr_bbox[1]));
        var left_to_right = new Segment(SavaneMath.getMiddle(arr_bbox[2], arr_bbox[3]), SavaneMath.getMiddle(arr_bbox[0], arr_bbox[1]));
        //Retrieve floor walls
        var walls = PlanManager.getInstance().world.currentScene!.currentFloor!.walls;
        for (i = 0; i < walls.length; i++) {
            //Get wall boudning box
            wall_bbox = walls[i].boundingBox;
            //Loop on all segment of bbox
            for (j = 0; j < wall_bbox.length; j++) { // FIXME only work for a 4 side polygon
                //Create segment
                wall_seg = new Segment(wall_bbox[j], wall_bbox[(j + 1) % 4]);
                //Calculate cross point of the two line
                if (!touch_wall_back) {
                    c_point = SavaneMath.getCrossPoint(front_to_back_seg.begin, front_to_back_seg.end, wall_seg.begin, wall_seg.end);
                    if (c_point !== null) {
                        //Check if the intersection point is inside the wall segment and close enough (under the precision)
                        if (math.vec3.dist(c_point, front_to_back_seg.begin) < KitchenTool.KitchenToolConstants.DefaultFillerLength &&
                            wall_seg.isPointOnSegment(c_point, KitchenTool.KitchenToolConstants.FillerPrecision)) {
                            //FIXME DIRTY
                            eventsManager.instance.dispatch('attach_item_to_wall', {
                                wall: walls[i].id,
                                arrangement: this.sketchBlock
                            });
                            touch_wall_back = true; //Arrangement is back on a wall
                            wall_thick = walls[i].thickness / 10;
                        }
                    }
                }
                if (this.sketchBlock.objectTypeConfig !== undefined && this.sketchBlock.objectTypeConfig !== null &&
                    this.sketchBlock.objectTypeConfig.angleDirection !== undefined && this.sketchBlock.objectTypeConfig.angleDirection !== 'none' && !touch_wall_angle) {
                    c_point = SavaneMath.getCrossPoint(left_to_right.begin, left_to_right.end, wall_seg.begin, wall_seg.end);
                    if (c_point !== null) {
                        //Check if the intersection point is inside the wall segment and close enough (under the precision)
                        if (math.vec3.dist(c_point, this.sketchBlock.objectTypeConfig.angleDirection == 'right' ? left_to_right.begin : left_to_right.end) < KitchenTool.KitchenToolConstants.DefaultFillerLength &&
                            wall_seg.isPointOnSegment(c_point, KitchenTool.KitchenToolConstants.FillerPrecision)) {
                            touch_wall_angle = true; //Arrangement is back on a wall
                            wall_thick_angle = walls[i].thickness / 10;
                        }
                    }
                }
                //Early leave
                if (this.sketchBlock.objectTypeConfig !== undefined && this.sketchBlock.objectTypeConfig !== null &&
                    this.sketchBlock.objectTypeConfig.angleDirection !== undefined && this.sketchBlock.objectTypeConfig.angleDirection !== 'none') {
                    if (touch_wall_angle) {
                        break;
                    }
                } else if (touch_wall_back) {
                    break;
                }
            }
        }
        var y_decal = 0;
        if (touch_wall_back) {
            y_decal = -((this.sketchBlock.width * 0.5 / 10) + wall_thick + 15 + this.dimLine * 15);

        }
        this.dimensionNode.setPosition(new cc.p(0, y_decal));
        var degAngle = (this.sketchBlock.angle / Math.PI) * 180;
        var flipped = (degAngle > 90 && degAngle <= 270) ||
            (degAngle < -90 && degAngle >= -270);
        this.dimensionNode.setFlipped(flipped);
        this.dimensionNode.setDimensionValue(this.sketchBlock.length / 10, PlanManager.getInstance().getZoomScale());
        //For angle arrangement draw lateral dimension
        if (this.sketchBlock.objectTypeConfig !== undefined && this.sketchBlock.objectTypeConfig !== null &&
            this.sketchBlock.objectTypeConfig.angleDirection !== undefined && this.sketchBlock.objectTypeConfig.angleDirection !== 'none') {
            var x_decal = 0;//this.sketchBlock.length * 0.5 / 10;
            if (touch_wall_angle) {
                x_decal = -((this.sketchBlock.length * 0.5 / 10) + wall_thick_angle + 15 + this.dimLine * 15);
                if (this.sketchBlock.objectTypeConfig.angleDirection == 'left') {
                    x_decal = -x_decal;
                }
            }
            var degAngle = (this.sketchBlock.angle / Math.PI) * 180;
            var flipped = (degAngle < 90 || degAngle > 270);
            if (this.angleDimensionNode) {
                this.angleDimensionNode.setPosition(new cc.p(x_decal, 0));
                this.angleDimensionNode.setFlipped(flipped);
                this.angleDimensionNode.setDimensionValue(this.sketchBlock.width / 10, PlanManager.getInstance().getZoomScale());
            }
        }
        //Finishes
        var finishes = this.sketchBlock.getComponent(ComponentConstants.ComponentType.FurnitureFinishes);
        if (finishes !== null) {
            //Fillers
            if (finishes.fillers.left != null && finishes.fillers.left_wall) {
                //Draw left only if wall
                if (this.leftFillerDimensions === null) {
                    this.leftFillerDimensions = new DimensionNode(this.dimColor);
                    this.leftFillerDimensions.setDimensionValue(finishes.fillers.left.length / 10, PlanManager.getInstance().getZoomScale());
                    this.addChild(this.leftFillerDimensions, 7);
                }
                this.leftFillerDimensions.setPosition(new cc.p(-(this.sketchBlock.length + finishes.fillers.left.length) * 0.5 / 10, y_decal));
                this.leftFillerDimensions.setFlipped(flipped);
            } else if (this.leftFillerDimensions !== null) {
                this.removeChild(this.leftFillerDimensions);
                this.leftFillerDimensions = null;
            }
            //Always draw right filler
            if (finishes.fillers.right != null) {
                if (this.rightFillerDimensions === null) {
                    this.rightFillerDimensions = new DimensionNode(this.dimColor);
                    this.rightFillerDimensions.setDimensionValue(finishes.fillers.right.length / 10, PlanManager.getInstance().getZoomScale());
                    this.addChild(this.rightFillerDimensions, 7);
                }
                this.rightFillerDimensions.setPosition(new cc.p((this.sketchBlock.length + finishes.fillers.right.length) * 0.5 / 10, y_decal));
                this.rightFillerDimensions.setFlipped(flipped);
            } else if (this.rightFillerDimensions !== null) {
                this.removeChild(this.rightFillerDimensions);
                this.rightFillerDimensions = null;
            }
        }
    }
    resetColor () {
        switch (this.sketchBlock.objectType) {
            case SceneConstants.ArrangementType.kitchenCooking:
            case SceneConstants.ArrangementType.kitchenCold:
            case SceneConstants.ArrangementType.kitchenHood:
            case SceneConstants.ArrangementType.kitchenWash:
            case SceneConstants.ArrangementType.kitchenFurnitureBottom:
            case SceneConstants.ArrangementType.kitchenFurnitureColumn:
                this.color = SketchBlockNode.DEFAULT_BOTTOM_COLOR;
                this.outlineColor = SketchBlockNode.DEFAULT_BOTTOM_OUTLINE_COLOR;
                break;
            case SceneConstants.ArrangementType.kitchenFurnitureTop:
                this.color = SketchBlockNode.DEFAULT_TOP_COLOR;
                this.outlineColor = SketchBlockNode.DEFAULT_TOP_OUTLINE_COLOR;
                break;
            default:
                this.color = SketchBlockNode.DEFAULT_COLOR;
                this.outlineColor = SketchBlockNode.DEFAULT_OUTLINE_COLOR;
                break;
        }
    }
    redraw () {
        //Draw node
        this.clear();
        //Draw a rectangle to match size of sketch block
        if (this.sketchBlock.objectTypeConfig && this.sketchBlock.objectTypeConfig !== null) {
            //*********DEBUG TO DISPLAY SKETCH BLOCK
            var sketchBlock = this.sketchBlock.getChildren([SceneConstants.EntityType.SketchBlock], []);
            if (sketchBlock.length > 0) {
                var sk = sketchBlock[0];
                this.drawRect(cc.p((sk.transform.localPosition[0] / 10) - (sk.length / 10) * 0.5, (sk.transform.localPosition[1] / 10) - (sk.width / 10) * 0.5),
                    cc.p((sk.transform.localPosition[0] / 10) + (sk.length / 10) * 0.5, (sk.transform.localPosition[1] / 10) + (sk.width / 10) * 0.5),
                    new cc.color(255, 128, 0, 10), 1, null);
            }
            //**************
            switch (this.sketchBlock.objectType) {
                case SceneConstants.ArrangementType.kitchenCooking:
                case SceneConstants.ArrangementType.kitchenCold:
                case SceneConstants.ArrangementType.kitchenHood:
                case SceneConstants.ArrangementType.kitchenWash:
                    this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                        null, 1, this.outlineColor);
                    this.drawSymbol(this.sketchBlock.objectType);
                    this.drawFacade(2);
                    break;
                case SceneConstants.ArrangementType.kitchenFurnitureBottom:
                    var startPoint = cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
                    var endPoint = cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
                    this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                        null, 1, this.outlineColor);
                    if (this.sketchBlock.objectTypeConfig.doorsCount > 0 && !this.sketchBlock.objectTypeConfig.downdoors) {
                        if (this.sketchBlock.objectTypeConfig.openingDirection) {
                            this.drawDoor(this.sketchBlock.objectTypeConfig.doorsCount, this.sketchBlock.objectTypeConfig.openingDirections.left, this.sketchBlock.objectTypeConfig.openingDirections.right);
                        }
                    }
                    if (this.sketchBlock.objectTypeConfig.drawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.drawersCount, false, this.sketchBlock.objectTypeConfig.bigDrawersCount);
                    }
                    if (this.sketchBlock.objectTypeConfig.bigDrawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.bigDrawersCount, true, 0);
                    }
                    this.drawFacade(1);
                    this.drawSides();
                    break;
                case SceneConstants.ArrangementType.kitchenFurnitureTop:
                    this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                        null, 1, this.outlineColor);
                    if (this.sketchBlock.objectTypeConfig.doorsCount > 0 && !this.sketchBlock.objectTypeConfig.downdoors) {
                        if (this.sketchBlock.objectTypeConfig.openingDirection) {
                            this.drawDoor(this.sketchBlock.objectTypeConfig.doorsCount, this.sketchBlock.objectTypeConfig.openingDirections.left, this.sketchBlock.objectTypeConfig.openingDirections.right);
                        }
                    }
                    if (this.sketchBlock.objectTypeConfig.drawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.drawersCount, false, this.sketchBlock.objectTypeConfig.bigDrawersCount);
                    }
                    if (this.sketchBlock.objectTypeConfig.bigDrawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.bigDrawersCount, true, 0);
                    }
                    this.drawCross();
                    this.drawFacade(1);
                    this.drawSides();
                    break;
                case SceneConstants.ArrangementType.kitchenFurnitureColumn:
                    this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                        null, 1, this.outlineColor);
                    if (this.sketchBlock.objectTypeConfig.doorsCount > 0 && !this.sketchBlock.objectTypeConfig.downdoors) {
                        this.drawDoor(this.sketchBlock.objectTypeConfig.doorsCount, this.sketchBlock.objectTypeConfig.openingDirections.left, this.sketchBlock.objectTypeConfig.openingDirections.right);
                    }
                    if (this.sketchBlock.objectTypeConfig.drawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.drawersCount, false, this.sketchBlock.objectTypeConfig.bigDrawersCount);
                    }
                    if (this.sketchBlock.objectTypeConfig.bigDrawersCount > 0) {
                        this.drawDrawers(this.sketchBlock.objectTypeConfig.bigDrawersCount, true, 0);
                    }
                    this.drawCross();
                    this.drawFacade(1);
                    if (this.sketchBlock.objectTypeConfig.builtinFridge) {
                        this.drawSymbol(SceneConstants.ArrangementType.fridge);
                    }
                    this.drawSides();
                    break;

                default:
                    this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                        null, 1, this.outlineColor);
                    this.drawFacade(2);
                    break;
            }
        } else {
            if (this.sketchBlock.objectType) {
                //Can't fin object custom info
                this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                    null, 1, this.outlineColor);
                this.drawSymbol(this.sketchBlock.objectType);
                this.drawFacade(2);
            } else {
                //Can't fin object custom info
                this.drawRect(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5),
                    null, 1, new cc.color(0, 70, 190, 125));
            }
        }
        this.drawSymbol(this.sketchBlock.objectType);
    }
    /**
     * Draw a cross inside the sketch block contours
     */
    drawCross () {
        this.drawSegment(cc.p(-(this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5), 0.5, this.outlineColor);
        this.drawSegment(cc.p((this.sketchBlock.length / 10) * 0.5, -(this.sketchBlock.width / 10) * 0.5), cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5), 0.5, this.outlineColor);
    }
    /**
     * Draw a lines representing doors
     * @param nbDoor {int} Number of doors
     * @param isLeft {boolean} Is there a door opening to left direction
     * @param isRight {boolean} Is there a door openint to right direction
     */
    drawDoor (nbDoor: number, isLeft: boolean, isRight: boolean) {
        if (nbDoor >= 1 && (!isLeft || !isRight)) {
            var startPoint = cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
            var endPoint = new cc.p(-startPoint.x, startPoint.y + 10);
            if (isLeft) {
                startPoint.x = -startPoint.x;
                endPoint.x = -endPoint.x;
            }
            this.drawSegment(startPoint, endPoint, 0.5, this.outlineColor);
        } else { //Double door
            var startPoint = cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
            var endPoint = new cc.p(-1, startPoint.y + 10);
            this.drawSegment(startPoint, endPoint, 0.5, this.outlineColor);
            var startPoint2 = cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
            var endPoint2 = new cc.p(1, startPoint.y + 10);
            this.drawSegment(startPoint2, endPoint2, 0.5, this.outlineColor);
        }
    }
    /**
     * Draw a line for each drawer (smaller each time  we add one)s
     * @param nbDrawers {int} Number of drawer to draw
     * @param isBig {boolean} Is a big drawer or a normal one
     * @param decal {int} Decal due to previously drawn drawer
     */
    drawDrawers (nbDrawers: number, isBig: boolean, decal: number) {
        var diff;
        var startPoint = cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
        var endPoint = cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
        for (var i = 0; i < nbDrawers; i++) {
            diff = (i + 1 + decal) * 6;
            //Draw a line representing the drawers
            var pointA = new cc.p(startPoint.x + diff, startPoint.y + diff);
            var pointB = new cc.p(endPoint.x - diff, endPoint.y + diff);
            this.drawSegment(pointA
                , pointB
                , 1, this.outlineColor);
            //If it's a big drawer add line end
            if (isBig) {
                this.drawSegment(new cc.p(pointA.x, pointA.y + 2)
                    , new cc.p(pointA.x, pointA.y - 2)
                    , 1, this.outlineColor);
                this.drawSegment(new cc.p(pointB.x, pointB.y + 2)
                    , new cc.p(pointB.x, pointB.y - 2)
                    , 1, this.outlineColor);
            }
        }
    }
    /**
    * Draw end planel as a small segment attach to side center
    *
    */
    drawSides () {
        var finishes = this.sketchBlock.getComponent(ComponentConstants.ComponentType.FurnitureFinishes);
        //Draw a line representing the drawers
        var startPoint = cc.p(-8, -8);
        var endPoint = cc.p(8, 8);
        if (finishes !== null && finishes.endPanels) {
            if (finishes.endPanels.left) {
                this.drawSegment(new cc.p(startPoint.x - (this.sketchBlock.length / 10) * 0.5, startPoint.y)
                    , new cc.p(endPoint.x - (this.sketchBlock.length / 10) * 0.5, endPoint.y)
                    , 1, this.outlineColor);
            }
            if (finishes.endPanels.right) {
                this.drawSegment(new cc.p(startPoint.x + (this.sketchBlock.length / 10) * 0.5, startPoint.y)
                    , new cc.p(endPoint.x + (this.sketchBlock.length / 10) * 0.5, endPoint.y)
                    , 1, this.outlineColor);
            }

        }
    }
    /**
     * TODO find a list of symbol to represent different arrangement type
     * @param type
     */
    drawSymbol (type: any) {
        var spritePath = null;
        switch (type) {
            case SceneConstants.ArrangementType.oven:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/oven.png';
                break;
            case SceneConstants.ArrangementType.microwave:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/microwave.png';
                break;
            case SceneConstants.ArrangementType.fridge:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/fridge.png';
                break;
            case SceneConstants.ArrangementType.cookingPlate:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/cookingplate.png';
                break;
            case SceneConstants.ArrangementType.sink:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/sink.png';
                break;
            case SceneConstants.ArrangementType.hood:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/hood.png';
                break;
            case SceneConstants.ArrangementType.dryer:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/dryer.png';
                break;
            case SceneConstants.ArrangementType.dishWasher:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/dishwasher.png';
                break;
            case SceneConstants.ArrangementType.washingMachine:
                spritePath = CocosConstants.resourcesBasePath + '/resources/appliance/washingmachine.png';
                break;
        }
        if (spritePath != null) {
            if (this.symbol == null) {
                this.symbol = new cc.Sprite();
                this.symbol.setAnchorPoint(new cc.p(0.5, 0.5));
                this.symbol.setScale(0.4);
                this.symbol.setRotation(90);
                this.addChild(this.symbol, -1);
            }
            this.symbol.setTexture(spritePath);
        }
    }
    /**
     * Draw a facade in front of object
     * @param thickness
     */
    drawFacade (thickness: number) {
        //Draw a line representing the drawers
        var startPoint = cc.p(-(this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
        var endPoint = cc.p((this.sketchBlock.length / 10) * 0.5, (this.sketchBlock.width / 10) * 0.5);
        var finishes = this.sketchBlock.getComponent(ComponentConstants.ComponentType.FurnitureFinishes);
        if (finishes !== null) {
            if (finishes.fillers.left !== null) {
                startPoint.x -= finishes.fillers.left.length / 10;
            }
            if (finishes.fillers.right !== null) {
                endPoint.x += finishes.fillers.right.length / 10;
            }
            if (finishes.fillers.left !== null || finishes.fillers.right !== null) {
                //Draw line if finishes
                this.drawSegment(new cc.p(startPoint.x, startPoint.y)
                    , new cc.p(endPoint.x, endPoint.y)
                    , 1, this.outlineColor);
            }
        }
        var yPos = (this.sketchBlock.width / 10) * 0.5;
        var arrrayLength = 10;

        this.drawSegment(new cc.p(0, yPos)
            , new cc.p(0, yPos + arrrayLength)
            , 1, this.outlineColor);
        //Arrow side
        this.drawSegment(new cc.p(4, yPos + arrrayLength - 4)
            , new cc.p(0, yPos + arrrayLength)
            , 1, this.outlineColor);
        this.drawSegment(new cc.p(-4, yPos + arrrayLength - 4)
            , new cc.p(0, yPos + arrrayLength)
            , 1, this.outlineColor);


        /*this.drawRect(
         cc.p(-(this.sketchBlock.length / 10)*0.5,-(this.sketchBlock.width / 10)*0.5),
         cc.p((this.sketchBlock.length / 10)*0.5,-(this.sketchBlock.width / 10)*0.5 - thickness),
         null, 1,  this.outlineColor);*/
    }
    setValidity (isValid: boolean) {
        if (isValid) {
            this.resetColor();
            /* this.color = SketchBlockNode.DEFAULT_COLOR;
             this.outlineColor = SketchBlockNode.DEFAULT_OUTLINE_COLOR;*/
        } else {
            this.color = SketchBlockNode.INVLALID_COLOR;
            this.outlineColor = SketchBlockNode.INVLALID_OUTLINE_COLOR;
        }
        this.redraw();
    }
    update () {
        /* var cocosPosition = GameObjectManager.convertToCocosCoord(this.sketchBlock.position);
         this.setPosition(cocosPosition);
         this.setRotation(-this.sketchBlock.angle * 180.0 / Math.PI);
         //Update rotation menu
         this.rotateMenu.update();*/
        //Recalculate dimension
        this.calculateDimensionsNodes();
    }
    onExit () {
        super.onExit();
        eventsManager.instance.dispatch('attach_item_to_wall', {
            wall: undefined,
            arrangement: this.sketchBlock
        });
    }
}
//COLORS
SketchBlockNode.DEFAULT_COLOR = new cc.color(80, 50, 255, 50);
SketchBlockNode.DEFAULT_OUTLINE_COLOR = new cc.color(50, 20, 255, 255);
SketchBlockNode.DEFAULT_BOTTOM_COLOR = new cc.color(80, 255, 50, 50);
SketchBlockNode.DEFAULT_BOTTOM_OUTLINE_COLOR = new cc.color(100, 255, 80, 255);
SketchBlockNode.DEFAULT_TOP_COLOR = new cc.color(80, 255, 50, 50);
SketchBlockNode.DEFAULT_TOP_OUTLINE_COLOR = new cc.color(200, 50, 255, 255);

SketchBlockNode.INVLALID_COLOR = new cc.color(255, 50, 80, 50); //RED
SketchBlockNode.INVLALID_OUTLINE_COLOR = new cc.color(255, 20, 50, 255); //RED
SketchBlockNode.SELECTED_COLOR = new cc.color(245, 210, 49, 50); //YELLOW
SketchBlockNode.SELECTED_OUTLINE_COLOR = new cc.color(245, 210, 49, 255); //YELLOW

SketchBlockNode.SYMBOL_COLOR = new cc.color(150, 150, 150, 255);
